import React, { useState } from 'react';
import classNames from 'classnames';
import * as Edge from '../../../core';
import './index.scss';
import { getPriceTitle, getPriceFeatures } from '../../../utilities/commerceUtil';
import * as StrUtil from '../../../utilities/strUtil';
import _ from 'lodash';

export interface ChooseProductProps {
	prices: Edge.Models.OrganizationAllowedPrice[];
	proratePercent?: number | null;
	currentPrice?: Edge.Models.Price;
	count?: number;
	onSelectPrice: (price: Edge.Models.OrganizationAllowedPrice) => void;
}

const getPriceTypeOrder = (priceType: Edge.Models.PriceType) => {
	switch (priceType) {
		case Edge.Models.PriceTypes.Recurring:
			return 0;
		case Edge.Models.PriceTypes.Subscription:
			return 1;
		case Edge.Models.PriceTypes.Sessions:
			return 2;
		case Edge.Models.PriceTypes.Glasses:
			return 3;
	}
};

const getPriceTypes = (prices: Edge.Models.OrganizationAllowedPrice[]) => {
	return _.orderBy(_.uniq(prices.map((i) => i.price.priceType)), getPriceTypeOrder);
};

const ChooseProduct: React.FC<ChooseProductProps> = (props) => {
	const [currentPriceType, setCurrentPriceType] = useState<Edge.Models.PriceTypes>(
		getPriceTypes(props.prices)[0] || Edge.Models.PriceTypes.Recurring
	);

	const { prices, currentPrice, count, onSelectPrice } = props;
	const priceTypes = getPriceTypes(prices);

	const priceSuffix = (price: Edge.Models.Price) => {
		switch (price.priceType) {
			case Edge.Models.PriceTypes.Subscription:
				return '/user';
			case Edge.Models.PriceTypes.Sessions:
				return `/${price.sessions} ${StrUtil.pluralize('session', price.sessions)}`;
			case Edge.Models.PriceTypes.Recurring:
				return '/subscription';
			default:
				return '';
		}
	};

	return (
		<div className="choose_product">
			<ul className="product_types">
				{priceTypes.map((t: Edge.Models.PriceTypes) => (
					<li
						className={classNames('product_type', { is_selected: t === currentPriceType })}
						key={t}
						onClick={() => setCurrentPriceType(t)}
					>
						{
							prices.find((p: Edge.Models.OrganizationAllowedPrice) => p.price.priceType === t)!.product
								.name
						}
					</li>
				))}
			</ul>
			{currentPrice && (
				<div className="current_product">
					<h4>
						Your current plan: <span className="current_product_value">{getPriceTitle(currentPrice)}</span>
					</h4>
				</div>
			)}
			<div className="products">
				{_.orderBy(
					prices.filter((p: Edge.Models.OrganizationAllowedPrice) => p.price.priceType === currentPriceType),
					(p: Edge.Models.OrganizationAllowedPrice) => p.price.unitAmount
				).map((p: Edge.Models.OrganizationAllowedPrice) => {
					const price = p.price.unitAmount;
					const totalPrice = count && p.price.priceType !== Edge.Models.PriceTypes.Recurring && price * count;
					return (
						<div
							key={p.price.id}
							className={classNames('product', {
								is_current: currentPrice && p.price.id === currentPrice.id,
							})}
							onClick={() => onSelectPrice(p)}
						>
							<div className="product_title_area">
								<h3>{getPriceTitle(p.price)}</h3>
								<h4>
									${price.toFixed(0)}
									{priceSuffix(p.price)}
									{count && p.price.priceType !== Edge.Models.PriceTypes.Recurring && ` * ${count}`}
									{totalPrice && ` = $${totalPrice.toFixed(0)}`}
								</h4>
							</div>
							<ul className="features">
								{getPriceFeatures(p).map((s: string) => (
									<li key={s}>{s}</li>
								))}
							</ul>
							<div className="cta_btn btn_bright">SELECT</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ChooseProduct;
